import React, { useState } from 'react'
import AddToCart from './AddToCart'
import { formatPrice } from '../utilities';

function ProductCard({ product, kit=false, extraClasses }) {
    const image = product.featured_image
    const modelNumber = product.variants[0].sku
    const available = product.available;
    const price = product.price
    const id = product.variants[0].id
    const { selling_plan_groups } = product;
    const selling_plans = selling_plan_groups[0].selling_plans
    const defaultSellingPlanId = selling_plans[0].id
    const [sellingPlanId, setSellingPlanId] = useState(defaultSellingPlanId);


    return (
        <article className={`flex ${!kit ? "flex-col p-4" : "p-4"} bg-white shadow-[0_6px_12px_rgb(0_0_0_/_0.5)] rounded-2xl text-brio-100 ${extraClasses}`}>
            <img src={image} className="max-w-[150px] m-auto" />
            <div className='flex flex-col gap-y-2 text-left'>
                <div className="uppercase text-[14px] font-normal">Model Number</div>
                <div className="text-white bg-brio-100 rounded-lg uppercase px-4 py-2">{modelNumber}</div>
                <div className="uppercase text-[14px] font-normal">Delivery Intervals*</div>
                <div className="relative">
                    <select onChange={(e) => setSellingPlanId(e.target.value)} className="bg-brio-100 px-4 py-2 w-full rounded-lg text-white" defaultValue={defaultSellingPlanId}>
                        {selling_plans.map((selling_plan) => {
                            return (<option key={selling_plan.id} value={selling_plan.id}>{selling_plan.options[0].value}</option>)
                        })}
                    </select>
                    <div className="pointer-events-none absolute right-[8px] -translate-x-1/2 border-b-[2px] border-r-[2px] top-[calc(50%-4px)] -translate-y-1/2 border-white z-10 w-4 h-4 rotate-45"></div>
                </div>
                <div className="text-[21px] font-bold flex gap-4"><del>{formatPrice(price)}</del><ins className="no-underline text-brio-600">{formatPrice(price * 0.8)}</ins></div>
                {available ? <AddToCart name={kit ? "kit" : "filters"} productId={id} sellingPlanId={sellingPlanId} extraClasses="text-white !text-2xl py-4" /> : <button className="bg-muted-200 rounded-lg font-bold py-4 px-3 text-white text-2xl">{"Out of Stock"}</button>}
            </div>
        </article>
    )
}

export default ProductCard